<template>
  <div>
    <b-overlay :show="loading">
      <employee-public-info  :hidebacknext="true"></employee-public-info>
      <b-row class="mt-3" v-if="can_edit">
        <b-col cols="12" md="12" class="d-flex justify-content-end align-items-center">
          <b-button variant="primary" @click="applyPenalty(0);">Grace Selected and Recalculate</b-button>
        </b-col>
      </b-row>

      <div class="mt-3 mb-3 p-3 ibox">
        <h6 class="mb-3 font-weight-bold">Attendance Summary</h6>
        <b-row class="text-center">
          <b-col>
            <div class="text-muted small">Total Days</div>
            <div class="h5 font-weight-bold">{{ summary.total }}</div>
          </b-col>
          <b-col>
            <div class="text-muted small">Present</div>
            <div class="h5 font-weight-bold text-success">{{ summary.present }}</div>
          </b-col>
          <b-col>
            <div class="text-muted small">Late</div>
            <div class="h5 font-weight-bold text-warning">{{ summary.late }}</div>
          </b-col>
          <b-col>
            <div class="text-muted small">Absent</div>
            <div class="h5 font-weight-bold text-danger">{{ summary.absent }}</div>
          </b-col>
          <b-col>
            <div class="text-muted small">Early Out</div>
            <div class="h5 font-weight-bold text-info">{{ summary.early }}</div>
          </b-col>
          <b-col>
            <div class="text-muted small">Incomplete</div>
            <div class="h5 font-weight-bold text-secondary">{{ summary.incomplete }}</div>
          </b-col>
        </b-row>
      </div>

      <div class="table-responsive employee-table-wrapper mt-3">
        <table class="employee-list-table table-overflow ess-custom-table document-table tax-documents table-list fund_list_table dataTable">
          <thead class="table-head">
          <tr>
            <td v-if="can_edit" class="checkbox-col pl-3">
              <input type="checkbox" class="m-0" v-model="selectAllDetails" @change="toggleAllDetails"/>
              <label for=""></label>
            </td>
            <th>Date</th>
            <th v-if="roster == 1">Shift</th>
            <th v-if="roster == 1">Shift Time</th>
            <th>Punch Time</th>
            <th>Work Time</th>
            <th>Late Clock In</th>
            <th>Early Clock Out</th>
            <th>Absent</th>
            <th>Incomplete Work Time</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, index) in penaltyDetails" :key="data.id" class="hover-bg table-row border-bottom mx-2">
            <td v-if="can_edit" class="checkbox-col pl-3">
              <input type="checkbox" class="m-0" :value="data.id" v-model="selectedDetailIds" @change="syncSelectAllDetails" />
              <label for=""></label>
            </td>
            <td>{{ data.date }}</td>
            <td v-if="roster == 1">{{ data.shift }}</td>
            <td v-if="roster == 1">{{ data.start_time }} - {{ data.end_time }}</td>
            <td :class="{ 'text-center': data.check_in == '' && data.check_out == '' }">{{ data.check_in }} - {{ data.check_out }}</td>
            <td :class="{ 'text-center': data.worktime == '-' }">{{ data.worktime }}</td>
            <td :class="{ 'text-center': data.late == '-' }">{{ data.late }}</td>
            <td :class="{ 'text-center': data.early == '-' }">{{ data.early }}</td>
            <td :class="{ 'text-center': data.absent == '-' }">{{ data.absent }}</td>
            <td :class="{ 'text-center': data.incomplete == '-' }">{{ data.incomplete }}</td>     
            <td>
              <span v-if="Number(data.grace) === 1" class="text-success"><i class="far fa-dot-circle mr-1"></i>Graced</span>
              <span v-else class="text-danger"><i class="far fa-dot-circle mr-1"></i>Not Graced</span>
            </td>
          </tr>
          <tr v-if="penaltyDetails.length == 0">
            <td colspan="11" class="text-center">No detail rows found.</td>
          </tr>
          </tbody>
        </table>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import moment from "moment";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  components: { FormWizard, TabContent },

  props:['row', 'can_edit'],
  data() {
    return {
      roster: 0,
      selected_run_action: "",
      date_range_mode: "",
      dateRangeModeOptions: [
        { text: "Include Date Range", value: "include" },
        { text: "Exclude Date Range", value: "exclude" }
      ],
      range_from_date: "",
      range_to_date: "",
      loading: false,
      currentStep: 0,
      maxUnlockedStep: 1,
      penalties: [],
      penaltyDetails: [],
      selectedDetailIds: [],
      selectAllDetails: false,
      selectedPenaltyId: null,
      selectedPenaltyIds: [],
      selectAllPenalties: false,
      selectedPenaltyRow: null,
      summary: {
        total: 0,
        present: 0,
        late: 0,
        absent: 0,
        early: 0,
        incomplete: 0,
        off_days: 0
      },
      emptytext: "No records found.",
      employee: {
        name: "",
        employee_code: "",
        pic: ""
      },
      fdata: {
        id: null,
        leave_deduct: 0,
        salary_deduct: 0,
        amount: 0,
        p_leave_deduct: 0,
        p_salary_deduct: 0,
        p_amount: 0
      },
      year: new Date().getFullYear(),
      month: String(new Date().getMonth() + 1).padStart(2, "0"),
      monthOptions: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" }
      ],
      yearOptions: [],
      penaltyFields: [
        { key: "employee_code", label: "Employee Code" },
        { key: "name", label: "Employee Name" },
        { key: "attendance_from", label: "From" },
        { key: "attendance_to", label: "To" },
        { key: "amount", label: "Deduction Days" },
        { key: "leave_deduct", label: "Leave Deduct" },
        { key: "leave_type", label: "Leave Category" },
        { key: "salary_deduct", label: "Salary Deduct (Days)" },
        { key: "status", label: "Status" }
      ]
    };
  },
  methods: {
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.roster = response.data.roster;
        }
      }.bind(this));
    },
    onComplete() {
      this.$bvToast.toast("Penalty flow completed.", {
        variant: "success",
        title: "Done",
        solid: true
      });
    },

    resetForm() {
      this.fdata = {
        id: null,
        leave_deduct: 0,
        salary_deduct: 0,
        amount: 0,
        p_leave_deduct: 0,
        p_salary_deduct: 0,
        p_amount: 0
      };
    },

    viewPenalty(data) {
      this.penaltyDetails = [];
      this.selectedDetailIds = [];
      this.selectAllDetails = false;

      this.employee = {
        name: "",
        employee_code: "",
        pic: ""
      };

      this.selectedPenaltyId = data.id;
      this.selectedPenaltyRow = data;
      this.loading = true;

      axios.get(this.$api_url + "/leave-attendance/penalty/details/" + this.selectedPenaltyId)
          .then(response => {
            let details = response.data.data || [];

            if (!Array.isArray(details)) {
              details = Object.values(details);
            }

            this.penaltyDetails = details.map(item => ({
              ...item,
              grace: Number(item.grace || 0)
            }));

            this.selectedDetailIds = this.penaltyDetails
                .filter(item => Number(item.grace) === 1)
                .map(item => item.id);

            this.syncSelectAllDetails();

            this.summary = response.data.summary || {
              total: 0,
              present: 0,
              late: 0,
              absent: 0,
              early: 0,
              incomplete: 0,
              off_days: 0
            };

            this.employee = response.data.employee || {
              name: "",
              employee_code: "",
              pic: ""
            };

            this.$bvModal.show("penalty-details-modal");
          })
          .catch(error => {
            this.serverError(error);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    toggleAllDetails() {
      if (this.selectAllDetails) {
          this.selectedDetailIds = this.penaltyDetails.map(item => item.id);
      } else {
          this.selectedDetailIds = [];
      }
  },

    syncSelectAllDetails() {
      this.selectAllDetails = this.penaltyDetails.length > 0
          && this.selectedDetailIds.length === this.penaltyDetails.length;
    },

    applyPenalty(status) {
      this.$bvModal.msgBoxConfirm("Are you sure?", {
        title: "Please Confirm",
        size: "sm",
        buttonSize: "sm",
        okVariant: "primary",
        okTitle: "Yes",
        cancelTitle: "Cancel",
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (!value) {
          return;
        }

        for (let i = 0; i < this.penaltyDetails.length; i++) {
          const isSelected = this.selectedDetailIds.indexOf(this.penaltyDetails[i].id) !== -1;

          this.$set(this.penaltyDetails[i], "grace", isSelected ? 1 : 0);
        }

        if (this.penaltyDetails.length == 0) {
          return;
        }

        try {
          const formData = new FormData();

          const dates = this.penaltyDetails.map(item => {
            return moment(item.date, "YYYY-MM-DD");
          });

          const from = moment.min(dates).format("YYYY-MM-DD");
          const to = moment.max(dates).format("YYYY-MM-DD");

          const penaltyGraceMap = this.penaltyDetails.reduce((acc, item) => {
            acc[item.id] = Number(item.grace);
            return acc;
          }, {});

          const employee_id = this.penaltyDetails[0].employee_id;

          formData.append("from", from);
          formData.append("to", to);
          formData.append("status", status);
          formData.append("employee_id", employee_id);
          formData.append("penalty_id", this.selectedPenaltyId);
          formData.append("penalty_grace", JSON.stringify(penaltyGraceMap));

          this.loading = true;

          axios.post(this.$api_url + "/leave-attendance/penalty/update", formData)
              .then(response => {
                this.$bvToast.toast(response.data.message, {
                  solid: true,
                  title: "Success",
                  variant: "success"
                });

                // this.$bvModal.hide("penalty-details-modal");
                this.$emit('reloadData');

                const reloadFormData = new FormData();
                reloadFormData.append("year", this.year);
                reloadFormData.append("month", this.month);

                axios.post(this.$api_url + "/leave-attendance/penalty/preview", reloadFormData)
                    .then(previewResponse => {
                      this.penalties = previewResponse.data || [];
                      this.loading = false;
                    })
                    .catch(() => {
                      this.loading = false;
                    });
              });
        } catch (e) {
          this.serverError(e);
        } finally {
          this.loading = false;
        }
      });
    },
  },

  created() {
    this.getCompanyLeaveSettings();
    this.viewPenalty(this.row);
  }
};
</script>
